var _path;
import * as React from "react";
function SvgClose(props) {
  return /*#__PURE__*/React.createElement("svg", props, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.395 20L33.65 9.744l2.115-2.115a.8.8 0 000-1.13l-2.263-2.264a.8.8 0 00-1.131 0L20 16.606 7.63 4.234a.8.8 0 00-1.132 0L4.234 6.497a.8.8 0 000 1.131L16.606 20 4.234 32.373a.8.8 0 000 1.13l2.263 2.264a.8.8 0 001.131 0L20 23.395 30.258 33.65l2.115 2.115a.8.8 0 001.13 0l2.264-2.263a.8.8 0 000-1.131L23.395 20z"
  })));
}
export default SvgClose;